module.exports = __webpack_public_path__ + "media/images/photo02-01a1557db23e9d9e10d9daa8501a7080.png";